import axios from 'axios';

import Constants from './Constants';

const oktaService = () => {
  const getCLHBOktaURL = () => {
    switch (Constants.ENVIRONMENT) {
      case 'LOCAL':
        return 'https://clienthub-qa.nepc.com/okta/api/v1';
      case 'QA':
        return 'https://clienthub-qa.nepc.com/okta/api/v1';
      case 'UAT':
        return 'https://clienthub-uat.nepc.com/okta/api/v1';
      case 'PROD':
        return 'https://clienthub.nepc.com/okta/api/v1';
    }
  };

  const URL = Constants.OKTA.URL;

  const registerUser = (user) => axios.post(`${URL}/register`, user);
  const loginExists = (email) => axios.get(`${getCLHBOktaURL()}/loginExists?email=${email}`);

  return {
    registerUser,
    loginExists,
  };
};

export default oktaService;
